import { createSlice } from "@reduxjs/toolkit";

const isJson = str => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};

const userSlice = createSlice({
	name: "user",
	initialState: {
		user: isJson(localStorage.getItem("user"))
			? JSON.parse(localStorage.getItem("user"))
			: null,
		token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
		refreshToken: localStorage.getItem("refreshToken"),
		isShowChangePasswordModal: false,
	},
	reducers: {
		setUserData: (state, { payload }) => {
			if (payload) {
				localStorage.setItem("user", JSON.stringify(payload));
			} else {
				localStorage.removeItem("user")
			}
			state.user = payload ? payload : null;
		},
		setToken: (state, { payload }) => {
			if (payload) {
				localStorage.setItem(
					"token",
					payload?.accessToken || payload.accessTocken,
				);
				localStorage.setItem(
					"refreshToken",
					payload?.refreshToken || payload.refreshTocken,
				);
			} else {
				localStorage.removeItem("token");
				localStorage.removeItem("refreshToken");
			}
			state.token = payload && payload?.accessToken ? payload?.accessToken : "";
			state.refreshToken = payload && payload?.refreshToken ? payload?.refreshToken : "";
		},
		logoutUser: state => {
			localStorage.clear();
			state.user = null;
			state.token = "";
			state.refreshToken = "";
		},
		setIsShowChangePasswordModal: (state, { payload }) => {
			state.isShowChangePasswordModal = payload || false;
		},
	},
});

export const { setUserData, setToken, logoutUser, setIsShowChangePasswordModal } =
	userSlice.actions;

export default userSlice.reducer;
